import { IInvoiceGroupReducer, IInvoiceGroup } from 'models/InvoiceGroup'
import { Action } from 'redux'
import { isType } from 'ts-action'
import { updateArray, deleteFromArray } from 'helpers/helperFunctions'
import {
  GetInvoiceGroups,
  InvoiceGroupsFetching,
  UpdateInvoiceGroup,
  DeleteInvoiceGroup,
  ClearInvoiceGroups,
} from './actions'

const initialState: IInvoiceGroupReducer = {
  meta: {
    code: 0,
    message: '',
  },
  isFetching: false,
  data: [],
}

export const invoiceGroupsReducer = (
  state = initialState,
  action: Action
): IInvoiceGroupReducer => {
  if (isType(action, GetInvoiceGroups)) {
    const { payload } = action
    return {
      ...state,
      meta: payload.meta,
      data: payload.data,
    }
  }
  if (isType(action, UpdateInvoiceGroup)) {
    const { payload } = action
    const { data } = state
    const formattedArray = updateArray<IInvoiceGroup>(data, payload.data)
    return {
      ...state,
      data: formattedArray,
    }
  }
  if (isType(action, DeleteInvoiceGroup)) {
    const { payload } = action
    const { data } = state
    const formattedArray = deleteFromArray<IInvoiceGroup>(data, payload)
    return {
      ...state,
      data: formattedArray,
    }
  }

  if (isType(action, InvoiceGroupsFetching)) {
    const { payload } = action
    return {
      ...state,
      isFetching: payload,
    }
  }

  if (isType(action, ClearInvoiceGroups)) {
    return initialState
  }
  return state
}
